var AIService, ChapterDoc, DOCUMENT_SECTIONS_V2_SECTION_TYPE, DbHelper, EtdActions, Exceptions, HANDOUTS_SECTIONS_MAPPING, MDA_HANDOUT, MINI_DS_SECTION_PREFIX, MdaTopicDoc, MiniDSDoc, PLR_CLIENT_TIMEOUT_MS, PMModel, Request, SectionDoc, W, addContentToSection, apiHelpers, applyPlrUpdatesToEtdDoc, applyRecommendationUpdatesToEtdDoc, callHandoutsApi, callMethod, callRecommendationsApi, concatReducer, fetchHandout, fetchTopic, findOrCreateSectionByChapterTitle, flatPluckCompact, generateGUID, get, getContentPromise, getSchema, handoutChaptersView, isAiRecommendationGenerationSupported, mapPlrToPatientsPresentation, mapRecommendationResponseToEtdUpdates, mediator, pluckDocsIndexById, processList, processSection, processTopicChapter, sequence, topicChaptersView, topicSectionsView, _ref, _ref1, _ref2, _ref3;

apiHelpers = require('actions/async/api_helpers');

_ref = require('base/lib/utils'), callMethod = _ref.callMethod, generateGUID = _ref.generateGUID;

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

DbHelper = require('base/lib/db_helper');

_ref1 = require('lib/db_docs/doc_types'), DOCUMENT_SECTIONS_V2_SECTION_TYPE = _ref1.DOCUMENT_SECTIONS_V2_SECTION_TYPE, MDA_HANDOUT = _ref1.MDA_HANDOUT;

flatPluckCompact = require('lib/app_utils').flatPluckCompact;

get = require('lodash').get;

getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;

getSchema = Epiditor.getSchema, PMModel = Epiditor.PMModel;

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MiniDSDoc = require('lib/db_docs/mini_ds_doc');

MINI_DS_SECTION_PREFIX = require('lib/doc_prefixes').miniDSSectionDoc;

mediator = require('mediator');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

sequence = require('when/sequence');

W = require('when/when');

Request = require('models/request');

Exceptions = require('lib/exceptions');

EtdActions = require('actions/etd_actions');

_ref2 = require('lib/plr_presentation_mapper'), applyPlrUpdatesToEtdDoc = _ref2.applyPlrUpdatesToEtdDoc, mapPlrToPatientsPresentation = _ref2.mapPlrToPatientsPresentation;

_ref3 = require('lib/recommendation_mapper'), applyRecommendationUpdatesToEtdDoc = _ref3.applyRecommendationUpdatesToEtdDoc, isAiRecommendationGenerationSupported = _ref3.isAiRecommendationGenerationSupported, mapRecommendationResponseToEtdUpdates = _ref3.mapRecommendationResponseToEtdUpdates;

PLR_CLIENT_TIMEOUT_MS = 20 * 60 * 1000;

handoutChaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.parentDocId, doc);
    }
  }
};

topicChaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.docSecRootId, doc);
    }
  }
};

topicSectionsView = {
  map: function(doc) {
    if (doc.type === 'document_sections_section') {
      return emit(doc.docSecRootId, doc);
    }
  }
};

pluckDocsIndexById = function(rows) {
  return _.chain(rows).pluck('doc').compact().indexBy('_id').value();
};

fetchHandout = function(adapter, projectId, mdaHandoutId) {
  var chaptersPromise, handoutPromise;
  handoutPromise = MiniDSDoc.at(mediator.project.id, mdaHandoutId).fetch();
  chaptersPromise = adapter.fetchWithView(projectId, 'handoutChaptersView', handoutChaptersView, mdaHandoutId);
  return W.all([handoutPromise, chaptersPromise]).then(function(_arg) {
    var chapters, handout, sectionIds;
    handout = _arg[0], chapters = _arg[1];
    sectionIds = flatPluckCompact(chapters, 'sections');
    return adapter.fetch(projectId, sectionIds).then(function(_arg1) {
      var rows, sections;
      rows = _arg1.rows;
      sections = pluckDocsIndexById(rows);
      return {
        chapters: chapters,
        handout: handout,
        sections: sections
      };
    });
  });
};

fetchTopic = function(adapter, projectId, topicId) {
  return MdaTopicDoc.at(projectId, topicId).fetch().then(function(topic) {
    var chaptersPromise, rootPromise, sectionsPromise, tablesPromise;
    rootPromise = adapter.fetch(projectId, topic.topicRootId);
    chaptersPromise = adapter.fetchWithView(projectId, 'chaptersV3', topicChaptersView, topic.topicRootId);
    sectionsPromise = adapter.fetchWithView(projectId, 'sectionsV3', topicSectionsView, topic.topicRootId);
    tablesPromise = _.isEmpty(topic.insertedTables) ? W.resolve([]) : adapter.fetch(projectId, topic.insertedTables);
    return W.all([rootPromise, chaptersPromise, sectionsPromise, tablesPromise]).then(function(_arg) {
      var chapters, chaptersDocs, rootDoc, sections, sectionsDocs, tables, tablesRows, _ref4;
      rootDoc = _arg[0], chaptersDocs = _arg[1], sectionsDocs = _arg[2], (_ref4 = _arg[3], tablesRows = _ref4.rows);
      tables = pluckDocsIndexById(tablesRows);
      chapters = _.indexBy(chaptersDocs, '_id');
      sections = _.indexBy(sectionsDocs, '_id');
      return {
        chapters: chapters,
        rootDoc: rootDoc,
        sections: sections,
        tables: tables,
        topic: topic
      };
    });
  });
};

processSection = function(_arg) {
  var content, section, sectionId, sections, tableDoc, tables, title, _ref4, _ref5, _ref6, _ref7, _ref8;
  sectionId = _arg.sectionId, sections = _arg.sections, tables = _arg.tables;
  section = sections[sectionId];
  if (section == null) {
    return W.resolve(null);
  }
  _ref8 = section.mdaTableId ? (tableDoc = tables[section.mdaTableId], [(_ref4 = tableDoc != null ? tableDoc.content : void 0) != null ? _ref4 : '', (_ref5 = tableDoc != null ? tableDoc.name : void 0) != null ? _ref5 : '']) : [(_ref6 = section.content) != null ? _ref6 : '', (_ref7 = section.title) != null ? _ref7 : ''], content = _ref8[0], title = _ref8[1];
  return getContentPromise("section_" + sectionId, content).then(function(htmlContent) {
    if (_.isEmpty(htmlContent)) {
      return null;
    } else {
      return "<h3>" + title + "</h3>\n" + htmlContent;
    }
  });
};

concatReducer = function(acc, item) {
  return "" + acc + "\n" + item;
};

processTopicChapter = function(_arg) {
  var chapter, chapterId, chapters, sections, sectionsInChapter, sectionsPromise, subchapters, subchaptersPromise, tables;
  chapterId = _arg.chapterId, chapters = _arg.chapters, sections = _arg.sections, tables = _arg.tables;
  chapter = chapters[chapterId];
  if (chapter == null) {
    return W.resolve(null);
  }
  subchapters = chapter.subchapters || [];
  sectionsInChapter = chapter.sections || [];
  subchaptersPromise = sequence(_.map(subchapters, function(subchapterId) {
    return function() {
      return processTopicChapter({
        chapterId: subchapterId,
        chapters: chapters,
        sections: sections,
        tables: tables
      });
    };
  }));
  sectionsPromise = sequence(_.map(sectionsInChapter, function(sectionId) {
    return function() {
      return processSection({
        sectionId: sectionId,
        sections: sections,
        tables: tables
      });
    };
  }));
  return W.all([subchaptersPromise, sectionsPromise]).then(function(_arg1) {
    var sectionsResults, subchaptersResults, text;
    subchaptersResults = _arg1[0], sectionsResults = _arg1[1];
    text = _.chain(sectionsResults).union(subchaptersResults).compact().reduce(concatReducer, '').value();
    return "<h2>" + chapter.title + "</h2>\n<div>" + text + "</div>";
  });
};

findOrCreateSectionByChapterTitle = function(chapters, sections, title) {
  var chapter, newId, section, sectionId;
  chapter = _.find(chapters, function(chapter) {
    return chapter.title === title;
  });
  if (!chapter) {
    throw new Error('No chapter with given title');
  }
  sectionId = _.first(chapter.sections);
  section = sectionId ? sections[sectionId] : null;
  if (section == null) {
    newId = "" + MINI_DS_SECTION_PREFIX + (generateGUID());
    return SectionDoc.at(mediator.project.id, newId).create({
      _id: newId,
      mdaTopicId: chapter.mdaTopicId,
      parent: chapter._id,
      title: '',
      content: '',
      type: DOCUMENT_SECTIONS_V2_SECTION_TYPE
    }).then(function(section) {
      return ChapterDoc.at(mediator.project.id, chapter._id).updateAsInstance(callMethod('addSections', [newId])).then(function() {
        sections[newId] = section;
        return section;
      });
    });
  } else {
    return W.resolve(section);
  }
};

processList = function(div, response) {
  var item, li, ul, _i, _len;
  ul = document.createElement('ul');
  for (_i = 0, _len = response.length; _i < _len; _i++) {
    item = response[_i];
    li = document.createElement('li');
    li.textContent = item;
    ul.appendChild(li);
  }
  return div.appendChild(ul);
};

addContentToSection = function(section, sectionMapping, response) {
  var content, div, node, noteP, noteText, p, responseList, timeline, timelines, titleH4, _i, _len;
  div = document.createElement('div');
  switch (sectionMapping.responseType) {
    case 'text':
      p = document.createElement('p');
      p.textContent = get(response, sectionMapping.responsePath, '');
      div.appendChild(p);
      break;
    case 'list':
      responseList = get(response, sectionMapping.responsePath, []);
      processList(div, responseList);
      break;
    case 'list_with_note':
      responseList = get(response, sectionMapping.responsePath, []);
      processList(div, responseList);
      noteText = get(response, sectionMapping.notePath, '');
      if (noteText != null) {
        noteP = document.createElement('p');
        noteP.textContent = noteText;
        noteP.style.fontStyle = 'italic';
        div.appendChild(noteP);
      }
      break;
    case 'list_of_timelines':
      timelines = get(response, sectionMapping.responsePath, []);
      if (_.isEmpty(timelines)) {
        p = document.createElement('p');
        p.textContent = $.t('mda:handouts.empty_list_of_timelines_content_placeholder');
        div.appendChild(p);
      } else {
        for (_i = 0, _len = timelines.length; _i < _len; _i++) {
          timeline = timelines[_i];
          titleH4 = document.createElement('h4');
          titleH4.textContent = timeline.title;
          div.appendChild(titleH4);
          processList(div, timeline.recovery_times_entries.map(function(entry) {
            return "" + entry.activity_type + ": " + entry.duration;
          }));
        }
      }
  }
  node = PMModel.DOMParser.fromSchema(getSchema()).parse(div);
  content = {
    doc: node.toJSON(),
    selection: {
      type: 'text',
      anchor: 0,
      head: 0
    },
    changeTracker: {
      changes: {}
    },
    annotations: {}
  };
  div.remove();
  return SectionDoc.at(mediator.project.id, section._id).updateAsInstance(callMethod('setProperty', 'content', content));
};

HANDOUTS_SECTIONS_MAPPING = [
  {
    chapterTitle: 'Overview',
    responsePath: 'overview',
    responseType: 'text'
  }, {
    chapterTitle: 'Recovery Expectations',
    responsePath: 'recovery_expectations',
    responseType: 'text'
  }, {
    chapterTitle: 'What to Consider',
    responsePath: 'what_to_consider',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Do',
    responsePath: 'returning_to_activity.to_do',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Avoid',
    responsePath: 'returning_to_activity.to_avoid',
    responseType: 'list'
  }, {
    chapterTitle: 'What to Adjust',
    responsePath: 'returning_to_activity.to_adjust',
    responseType: 'list'
  }, {
    chapterTitle: 'Checklist for Healing',
    responsePath: 'checklist_for_healing.recovery_checklist',
    notePath: 'checklist_for_healing.remember_note',
    responseType: 'list_with_note'
  }, {
    chapterTitle: 'Return to Activity Timeline',
    responsePath: 'recovery_times',
    responseType: 'list_of_timelines'
  }
];

callHandoutsApi = function(text, title) {
  return apiHelpers.ajax({
    contentType: 'application/json',
    data: JSON.stringify({
      text: text,
      title: title
    }),
    dataType: 'json',
    type: 'POST',
    url: "" + (DbHelper.getBackendUrl()) + "/ai/handouts/" + mediator.project.id + "/_generate",
    xhrFields: {
      withCredentials: true
    }
  });
};

callRecommendationsApi = function(projectId, etdJson) {
  return apiHelpers.ajax({
    contentType: 'application/json',
    data: JSON.stringify({
      etdJson: etdJson
    }),
    dataType: 'json',
    type: 'POST',
    url: "" + (DbHelper.getBackendUrl()) + "/ai/recommendations/" + projectId + "/_generate",
    xhrFields: {
      withCredentials: true
    }
  });
};

module.exports = AIService = (function() {
  function AIService(adapter) {
    this.adapter = adapter;
    this._plrInFlight = {};
    this._recommendationInFlight = {};
  }

  AIService.prototype._createPlrRequest = function(etdJson, extras) {
    var request;
    if (extras == null) {
      extras = {};
    }
    request = new Request(_.extend({}, extras, {
      type: 'generate_plr',
      status: 'new',
      etdJson: etdJson
    }));
    mediator.user.getRequests().add(request);
    return request.save();
  };

  AIService.prototype._watchPlrStatus = function(request, timeoutMs) {
    if (timeoutMs == null) {
      timeoutMs = PLR_CLIENT_TIMEOUT_MS;
    }
    return W.promise(function(resolve, reject) {
      var finish, onStatusChange, settled, timer;
      settled = false;
      timer = null;
      finish = function(fn) {
        if (settled) {
          return;
        }
        settled = true;
        if (timer != null) {
          clearTimeout(timer);
        }
        request.off('change:status', onStatusChange);
        return fn();
      };
      onStatusChange = function() {
        switch (request.get('status')) {
          case 'complete':
            return finish(function() {
              return resolve(request.get('result'));
            });
          case 'failure':
          case 'invalid':
            return finish(function() {
              return reject(new Exceptions.server_reported(request.get('message') || 'PLR generation failed'));
            });
        }
      };
      timer = setTimeout(function() {
        return finish(function() {
          return reject(new Exceptions.server_reported('PLR generation timed out'));
        });
      }, timeoutMs);
      request.on('change:status', onStatusChange);
      return onStatusChange();
    });
  };

  AIService.prototype.generatePlr = function(etdJson, extras, timeoutMs) {
    if (extras == null) {
      extras = {};
    }
    if (timeoutMs == null) {
      timeoutMs = PLR_CLIENT_TIMEOUT_MS;
    }
    return this._createPlrRequest(etdJson, extras).then((function(_this) {
      return function(request) {
        var promise;
        promise = _this._watchPlrStatus(request, timeoutMs);
        return promise;
      };
    })(this));
  };

  AIService.prototype._persistGeneratedPlr = function(projectId, recommendationId, updates) {
    return this.adapter.fetch(projectId, recommendationId, {
      attachments: true
    }).then((function(_this) {
      return function(etdDoc) {
        if ((etdDoc != null ? etdDoc._id : void 0) !== recommendationId) {
          throw new Exceptions.server_reported('Recommendation document is missing');
        }
        return _this.adapter.save(projectId, applyPlrUpdatesToEtdDoc(etdDoc, updates));
      };
    })(this));
  };

  AIService.prototype.generatePlrForQuestion = function(questionId, options) {
    var inFlightKey, projectId, recommendationId, timeoutMs, work, _ref4;
    if (options == null) {
      options = {};
    }
    if (_.isNumber(options)) {
      options = {
        timeoutMs: options
      };
    }
    timeoutMs = (_ref4 = options.timeoutMs) != null ? _ref4 : PLR_CLIENT_TIMEOUT_MS;
    recommendationId = options.recommendationId;
    projectId = mediator.project.id;
    inFlightKey = "" + projectId + ":" + questionId;
    if (this._plrInFlight[inFlightKey]) {
      return W.reject(new Exceptions.server_reported('PLR generation already in progress'));
    }
    if (!recommendationId) {
      return W.reject(new Exceptions.server_reported('No recommendation to generate PLR from'));
    }
    work = W(void 0).then((function(_this) {
      return function() {
        return mediator.services.covidExporter.exportQuestion(projectId, questionId, {
          exportPlrs: true,
          exportAssessmentTextSections: true,
          ignoreStatuses: true,
          exportEtdPrintout: false,
          recommendationId: recommendationId
        }).then(function(etdJson) {
          if (!etdJson) {
            throw new Exceptions.server_reported('No recommendation to generate PLR from');
          }
          return _this.generatePlr(etdJson, {
            projectId: projectId,
            questionId: questionId,
            recommendationId: recommendationId
          }, timeoutMs).then(function(result) {
            var plr, updates, _ref5;
            if (!(result != null ? result.success : void 0)) {
              throw new Exceptions.server_reported((result != null ? result.error_message : void 0) || (result != null ? result.message : void 0) || 'PLR generation failed');
            }
            plr = (_ref5 = result.data) != null ? _ref5.plr : void 0;
            if (!plr) {
              throw new Exceptions.server_reported('PLR result is missing');
            }
            updates = mapPlrToPatientsPresentation(plr, Boolean(etdJson.gps));
            return _this._persistGeneratedPlr(projectId, recommendationId, updates).then(function() {
              EtdActions.applyGeneratedPlr(_.extend({}, updates, {
                projectId: projectId,
                recommendationId: recommendationId
              }));
              return result;
            });
          });
        });
      };
    })(this));
    this._plrInFlight[inFlightKey] = work;
    return work.ensure((function(_this) {
      return function() {
        return delete _this._plrInFlight[inFlightKey];
      };
    })(this));
  };

  AIService.prototype._persistGeneratedRecommendation = function(projectId, recommendationId, response, isConsensus) {
    if (isConsensus == null) {
      isConsensus = false;
    }
    return this.adapter.fetch(projectId, recommendationId, {
      attachments: true
    }).then((function(_this) {
      return function(etdDoc) {
        var updates;
        if ((etdDoc != null ? etdDoc._id : void 0) !== recommendationId) {
          throw new Exceptions.server_reported('Recommendation document is missing');
        }
        updates = mapRecommendationResponseToEtdUpdates(response, etdDoc, {
          isConsensus: isConsensus
        });
        return _this.adapter.save(projectId, applyRecommendationUpdatesToEtdDoc(etdDoc, updates)).then(function() {
          return updates;
        });
      };
    })(this));
  };

  AIService.prototype.generateRecommendationForQuestion = function(questionId, options) {
    var inFlightKey, isConsensus, projectId, recommendationId, work, _ref4;
    if (options == null) {
      options = {};
    }
    isConsensus = (_ref4 = options.isConsensus) != null ? _ref4 : false;
    recommendationId = options.recommendationId;
    projectId = mediator.project.id;
    inFlightKey = "" + projectId + ":" + questionId;
    if (this._recommendationInFlight[inFlightKey]) {
      return W.reject(new Exceptions.server_reported('AI recommendation generation already in progress'));
    }
    if (!recommendationId) {
      return W.reject(new Exceptions.server_reported('No recommendation to generate from'));
    }
    work = this.adapter.fetch(projectId, recommendationId, {
      attachments: true
    }).then((function(_this) {
      return function(etdDoc) {
        if (!isAiRecommendationGenerationSupported(etdDoc)) {
          throw new Exceptions.server_reported('AI recommendation generation is not supported for this template');
        }
        return mediator.services.covidExporter.exportQuestion(projectId, questionId, {
          exportPlrs: true,
          exportAssessmentTextSections: true,
          ignoreStatuses: true,
          exportEtdPrintout: false,
          allowEmptyRecommendation: true,
          exportConsensusFields: isConsensus,
          recommendationId: recommendationId
        }).then(function(exportedEtdJson) {
          if (!exportedEtdJson) {
            throw new Exceptions.server_reported('No recommendation to generate from');
          }
          return callRecommendationsApi(projectId, exportedEtdJson).then(function(response) {
            return _this._persistGeneratedRecommendation(projectId, recommendationId, response, isConsensus).then(function(updates) {
              EtdActions.applyGeneratedRecommendation(_.extend({}, updates, {
                projectId: projectId,
                recommendationId: recommendationId
              }));
              return response;
            });
          });
        });
      };
    })(this));
    this._recommendationInFlight[inFlightKey] = work;
    return work.ensure((function(_this) {
      return function() {
        return delete _this._recommendationInFlight[inFlightKey];
      };
    })(this));
  };

  AIService.prototype.generateHandoutContent = function(mdaHandoutId) {
    return fetchHandout(this.adapter, mediator.project.id, mdaHandoutId).then((function(_this) {
      return function(_arg) {
        var chapters, handout, sections, _ref4;
        chapters = _arg.chapters, handout = _arg.handout, sections = _arg.sections;
        if ((handout != null ? handout.docType : void 0) !== MDA_HANDOUT) {
          throw new Error('Unsupported type');
        }
        if (!(handout != null ? (_ref4 = handout.options) != null ? _ref4.parentTopicId : void 0 : void 0)) {
          throw new Error('No topic id');
        }
        return fetchTopic(_this.adapter, mediator.project.id, handout.options.parentTopicId).then(function(topicData) {
          var _ref5;
          return sequence(_.map((_ref5 = topicData.rootDoc.chaptersOrder) != null ? _ref5 : [], function(chapterId) {
            return function() {
              return processTopicChapter({
                chapterId: chapterId,
                chapters: topicData.chapters,
                sections: topicData.sections,
                tables: topicData.tables
              });
            };
          })).then(function(chapterContents) {
            var fullContent, fullText;
            fullContent = _.chain(chapterContents).compact().reduce(concatReducer, '').value();
            fullText = "<h1>" + topicData.topic.name + "</h1>\n" + fullContent;
            return callHandoutsApi(fullText, topicData.topic.name);
          });
        }).then(function(response) {
          return sequence(_.map(HANDOUTS_SECTIONS_MAPPING, function(sectionMapping) {
            return function() {
              return findOrCreateSectionByChapterTitle(chapters, sections, sectionMapping.chapterTitle).then(function(section) {
                return addContentToSection(section, sectionMapping, response);
              });
            };
          }));
        });
      };
    })(this));
  };

  return AIService;

})();
